import { render, staticRenderFns } from "./SiniestroAutos.vue?vue&type=template&id=315c745c&scoped=true&"
import script from "./SiniestroAutos.vue?vue&type=script&lang=js&"
export * from "./SiniestroAutos.vue?vue&type=script&lang=js&"
import style0 from "./SiniestroAutos.vue?vue&type=style&index=0&id=315c745c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315c745c",
  null
  
)

export default component.exports